<template>
  <!-- 分享完成 -->
  <div class="share-finish">
    <!-- title -->
    <headers :params="hraderP"></headers>
    <!-- 分享成功 -->
    <div class="share-finish__header">
      <img src="../../../assets/images/share_finish.png" alt="">
      <p>恭喜您，分享成功！</p>
    </div>
    <div class="share-finish__center">
      <div class="guide-title">您可以通过以下两个方式进行下载：</div>
      <div class="guide-step">
        <div class="guide-step-label">方式一：在电脑端输入以下下载码；</div>
        <div class="download-code"><span v-for="(item, index) of code" :key="index">{{item}}</span></div>
      </div>
      <div class="guide-step" v-if="notLogin">
        <div class="guide-step-label">方式二：在手机端直接下载。当前未登录，登录后立即下载！</div>
        <div class="login">
          <button @click="login">立即登录</button>
        </div>
      </div>
      <div class="guide-step" v-else>
        <div class="guide-step-label">方式二：在手机端直接下载。文件将发送到您的邮箱：</div>
        <div class="send-email">
          <input type="text" v-model="email" placeholder="例如：289778997@qq.com" />
          <button @click="sendEmail">发送</button>
        </div>
      </div>
    </div>
    <!-- 下载次数上限-提示 -->
    <download-limit ref="downloadLimit"></download-limit>
  </div>
</template>

<script>
import headers from '@/components/headers'
import { queryDownloadCode, batchDownload, createFreeOrder , queryCreateOrderNo, creatOrderInfo ,getOrderInfoByOrderNo} from '@/api/solutions/solution'
import {regular} from '@/utils/regular'
import { Toast } from 'vant'
import { getCookie } from '@/utils/cookies'
import { toLogin } from '@/utils/common'
import downloadLimit from './download_limit'

export default {
  name: 'share-finish',
  components: { headers, downloadLimit },
  data () {
    return {
      hraderP: {
        title: '方案馆',
        lefticon: true
      },
      bizId: null,
      activeId: null,
      code: [],
      email: null,

      notLogin: null,

      toast: null,
      detail: null,

      orderNo: null,
      ajaxNum: 0,
      orderId: null
    }
  },
  mounted () {
    this.bizId = this.$route.params.bizId
    this.activeId = this.$route.params.activeId
    this.queryCode()
    if (!getCookie('ticket')) {
      this.notLogin = true
    } else if ($HMD$.rNavigator === 'msite' && (!getCookie('AccountId') && !getCookie('accountId'))) {
      this.notLogin = true
    }
    this.initData()
    this.getCreateOrderNo()
  },
  methods: {
    initData () {
      if (!this.bizId || this.bizId === 'undefined') return
      let self = this
      self.$store.dispatch('SOLUTIONS_GET_DETAIL', this.bizId).then(result => {
        if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
          self.detail = result.data.data
          console.log(self.detail)
        }
      })
    },
    // 获取平台唯一销售订单编号orderNo
    getCreateOrderNo () {
      queryCreateOrderNo().then(res => {
        if (res.status !== 200) {
          return
        }
        if (res.data.respCode !== '0000') {
          return
        }
        this.orderNo = res.data.respDesc
      })
    },
    /**
     * 查询下载code
     */
    queryCode () {
      queryDownloadCode(this.bizId).then(result => {
        if (result.status === 200 && result.data && result.data.respCode === '0000' && result.data.data) {
          if (!result.data.data.freeOrderDownloadCode) {
            console.log('下载码不存在')
            return
          }
          this.code = result.data.data.freeOrderDownloadCode.toString().split('')
        }
      })
    },
    sendEmail () {
      // 发送邮箱
      if (!this.email || !regular.email.test(this.email)) {
        Toast('请输入正确的邮箱地址')
        return
      }
      this.toast = Toast.loading({
        message: '发送中...',
        forbidClick: true,
        duration: 0
      })
      if (this.detail && getCookie('AccountId') && getCookie('AccountId') === `${this.detail.userId}`) {
        this.touchDowload()
        return
      }
      this.ajaxNum = 0
      this.postCreatOrderInfo()
    },
    getAppAccountId() {
      return new Promise((resolve, reject) =>{
        $HMD$.GetLogin(function (data) {
          resolve(data && data.AccountId || '')
        })
      });
    },
    async postCreatOrderInfo() {
      let param = {
        businessId:this.detail.solutionId,
        businessName: this.detail.solutionName,
        businessType: this.detail.solutionType,
        amount:0,
        userId: getCookie('accountId')  || getCookie('AccountId') ,
        os : $HMD$.rNavigator && $HMD$.rNavigator == 'msite' ? 'wap' : $HMD$.rNavigator,
        // returnUrl : 'https://pay.' + $HMD$.rApi.S + 'homedo.com/Cashier/FrontReturnCallback',
        orderNo: this.orderNo
      }
      if ($HMD$.rNavigator !== 'msite' && !param.userId) {
        param.userId = await this.getAppAccountId()
      }
      creatOrderInfo(param).then(res => {
        if (res.status === 200 && res.data && res.data.respCode === '0000') {
          this.queryOrderInfoByOrderNo()
        } else {
          this.toast.clear()
          Toast.fail(res.data.respDesc || '调用失败')
        }
      })
    },
    queryOrderInfoByOrderNo() {
      let t = setInterval(() => {
        this.ajaxNum += 1
        if (this.ajaxNum > 10) {
            clearInterval(t)
            this.toast.clear()
            Toast.fail('连接超时')
            return
        }
        getOrderInfoByOrderNo(this.orderNo).then((res) => {
          if (res.data.code !== 1000 && res.data.msg === '处理成功') {
            this.orderId = res.data.code
            clearInterval(t)
            this.createNewFreeOrder()
          }
        })
      }, 1000)
    },
    createNewFreeOrder() {
      // 限免
      const form = {
        activityId: this.activeId,
        solutionId: this.bizId,
        orderNo: this.orderId
      }
      createFreeOrder(form).then(async result => {
        if (result.status === 200 && result.data) {
          if (result.data.respCode === '0000') {
            await this.touchDowload()
          } else if (result.data.respCode === '0003') {
            if (result.data.respDesc && result.data.respDesc.indexOf('上限') > -1) {
              this.toast.clear()
              this.$refs.downloadLimit.orderStatusText = '限免'
              this.$refs.downloadLimit.show = true
            }
            if (result.data.respDesc && result.data.respDesc.indexOf('重复创建') > -1) {
              await this.touchDowload()
            }
          } else {
            this.toast.clear()
            Toast.fail(result.data.respDesc)
          }
        }
      })
    },
    touchDowload () {
      // 下载
      batchDownload(this.bizId, this.email).then(result => {
        if (result.status === 200 && result.data && result.data.code === 460) {
          // 登录失效
          toLogin()
          return
        }
        if (result.status === 200 && result.data && result.data.respCode === '0000') {
          // 下载完成
          this.toast.clear()
          Toast.success('发送成功')
        } else if (result.data.respCode === '0003') {
          if (result.data.respDesc && result.data.respDesc.indexOf('上限') > -1) {
            this.toast.clear()
            this.$refs.downloadLimit.orderStatusText = '限免'
            this.$refs.downloadLimit.show = true
          }
        } else {
          this.toast.clear()
          Toast.fail(result.data.respDesc)
        }
      }).catch(() => {
        this.toast.clear()
        Toast.fail('请求超时，请稍后重试！')
      })
    },
    // 去登陆
    login () {
      toLogin()
    }
  }
}
</script>

<style lang="less" scoped>
.share-finish {
  height: 100%;
  background-color: #ffffff;
  &__header{
    padding-top: 40px;
    margin-bottom: 20px;
    text-align: center;
    font-size:18px;
    font-weight: bold;
    color:rgba(51,51,51,1);
    line-height:18px;
    img{
      width: 49px;
      height: 49px;
      margin-bottom: 18px;
    }
  }
  &__center {
    padding: 0 16px;
    .guide-title{
      font-size:15px;
      color:rgba(51,51,51,1);
      line-height:21px;
    }
    .guide-step{
      &-label{
        margin-top: 8px;
        font-size:15px;
        color:rgba(153,153,153,1);
        line-height:21px;
      }
      .download-code{
        padding: 0 12px;
        box-sizing: border-box;
        margin-top: 13px;
        margin-bottom: 22px;
        span{
          display: inline-block;
          text-align: center;
          font-size:24px;
          color:rgba(153,153,153,1);
          display: inline-block;
          width:40px;
          height:40px;
          line-height: 40px;
          border-radius:2px;
          border:1px solid rgba(204,204,204,1);
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .login{
        margin-top: 18px;
        text-align: center;
        button{
          width:179px;
          height:44px;
          background:rgba(47,123,255,1);
          border-radius:22px;
          font-size:17px;
          font-weight: bold;
          color:rgba(255,255,255,1);
          outline: none;
          border: none;
        }
      }
      .send-email{
        margin-top: 13px;
        font-size: 0px;
        width:343px;
        height:45px;
        background:rgba(255,255,255,1);
        border-radius:3px;
        border:1px solid rgba(235,235,235,1);
        input{
          box-sizing: border-box;
          padding: 0 14px;
          font-size:15px;
          width: 273px;
          height:45px;
          vertical-align: top;
          border: none;
          outline: none;
        }
        button{
          vertical-align: top;
          border: none;
          outline: none;
          width:70px;
          height:45px;
          background:rgba(47,123,255,1);
          border-radius:0px 3px 3px 0px;
          font-size:15px;
          color:rgba(255,255,255,1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/share_finish.vue